import { ActionLabels } from '@sbv-clients/util-misc';

import {
  Button,
  Dialog,
  DialogActionsContainer,
  DialogContent,
  DialogHeader,
  useToggleModal,
} from '../../index';

export const useDeleteConfirmationModal = (
  handleDelete: () => void,
  title: string,
  content: string
) => {
  const { open, openModal, closeModal } = useToggleModal();

  const handleDeleteWithClose = () => {
    handleDelete();
    closeModal();
  };

  const modal = () => {
    return (
      <Dialog open={open} fullWidth>
        <DialogHeader title={title} onClose={closeModal} />
        <DialogContent sx={{ mt: 6 }}>{content}</DialogContent>
        <DialogActionsContainer>
          <Button variant="outlined" onClick={closeModal}>
            {ActionLabels.Cancel}
          </Button>
          <Button variant="contained" onClick={handleDeleteWithClose}>
            {ActionLabels.Confirm}
          </Button>
        </DialogActionsContainer>
      </Dialog>
    );
  };

  return {
    modal,
    openModal,
  };
};
